module.exports = __webpack_public_path__ + "img/remark5.00545d40.png";